import * as FullStory from '@fullstory/browser';
import sharedConfig from 'shared-assets/src/config-environments/config';
import somePathAsserted from 'shared-assets/lib/utils/paths/path-assertion';

/**
 * Checks if at least one of the pathsToAssert matches with the current path
 * @function initFullstory
 * @return {void}
 */
const initFullstory = () => {
    if(sharedConfig?.fullstoryConfig?.enabled && 
        !somePathAsserted(window.location.pathname + window.location.hash, sharedConfig?.fullstoryConfig?.untrackedPaths)
    ) {
        FullStory.init({ orgId: sharedConfig?.fullstoryConfig?.orgId });
    }
}

initFullstory();
